import {
    DELETE_LEAD_REQUEST,
    DELETE_LEAD_REQUEST_SUCCESS,
    DELETE_LEAD_REQUEST_FAILURE,
} from '../constants/delete_lead.constants';

export const deleteLeadRequest = leadId => ({
    type: DELETE_LEAD_REQUEST,
    leadId,
});


export const deleteLeadSuccess = result => ({
    type: DELETE_LEAD_REQUEST_SUCCESS,
    result,
});

export const deleteLeadFailure = error => ({
    type: DELETE_LEAD_REQUEST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/delete_lead.actions.js